import Banner from 'Components/banner/banner_server'
import BannerClient from 'Components/banner/banner_client'
import MosPopular from 'Components/most-popular'
import BeautyFiles from 'components/beauty-files'
import VideoBlog from 'components/video-blog'

const Sidebar = ({ is_mobile, popularArticles, video, beautyFiles, ads, isClient }) => {

  return (
    <div className="sidebar-body">

      {/* This is for only client side rendering */}
      {
        isClient && (
          <div className="ads-banner-wrapper-1">
            <BannerClient
              name="mediumrectangle1"
              placeholder="mediumrectangle1"
              is_mobile={false}
              class_name="ads-medium-rectangle1"
              dataAds={ads?.mediumrectangle1}
              isLoading={ads?.isLoading}
            />
          </div>
        )
      }

      {
        ads?.mediumrectangle1 && !isClient ?
          <div className="ads-banner-wrapper-1">
            <Banner
              name="mediumrectangle1"
              placeholder="mediumrectangle1"
              is_mobile={false}
              class_name="ads-medium-rectangle1"
              dataAds={ads?.mediumrectangle1}
            />
          </div>
          : null
      }

      {!!popularArticles && <MosPopular popularArticles={popularArticles} isMobile={is_mobile} />}
      {!!beautyFiles && <BeautyFiles beautyFiles={beautyFiles} />}
      {!!video && <VideoBlog video={video} />}

      {
        isClient && (
          <div className="ads-banner-wrapper">
            <BannerClient
              name="mediumrectangle2"
              placeholder="mediumrectangle2"
              is_mobile={false}
              class_name="ads-medium-rectangle2"
              dataAds={ads?.mediumrectangle2}
              isLoading={ads?.isLoading}
            />
          </div>
        )
      }

      {
        ads?.mediumrectangle2 && !isClient ?
          <div className="ads-banner-wrapper">
            <Banner
              name="mediumrectangle2"
              placeholder="mediumrectangle2"
              is_mobile={false}
              class_name="ads-medium-rectangle2"
              dataAds={ads?.mediumrectangle2}
            />
          </div>
          : null
      }

      <style>
        {`
          .ads-banner-wrapper img {
            width: 300px;
          }

          .sidebar-body {
            font-family: Josefin Sans, sans-serif;
						display: flex;
						flex-direction: column;
						gap: 40px;
          }

          .sidebar-body .sidebar-content {
            border: 1px solid #DFE3E8;
            padding: 0 20px 24px 20px;
          }

          .sidebar-body .ads-banner-wrapper:empty,
          .ads-banner-wrapper-1:empty,
          .sidebar-body .sidebar-content:empty {
            margin-bottom: 0;
          }

          .sidebar-body .sidebar-title-wrapper {
            text-align: center;
            margin: -10px 0 20px 0;
          }

          .sidebar-body .sidebar-content-title {
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            padding-left: 12px;
            padding-right: 12px;
            background-color: #FFF;
            display: inline-block;
            margin: 0;
          }

          .sidebar-body .article-content .article-image {
            width: 56px;
            height: 56px;
          }

          .sidebar-body .article-content .article-title a {
            font-size: 14px;
            line-height: 18px;
          }

          .sidebar-body .article-content .article-title p {
            margin-top: 4px;
            font-size: 12px;
            line-height: 20px;
          }

          #sidebar-beauty-files {
            text-align: center;
          }

          #sidebar-beauty-files img {
            margin-bottom: 16px;
            cursor: pointer;
            transition: .2s ease;
          }

          #sidebar-beauty-files img:hover {
            opacity: .6;
          }

          .highlight-wrapper {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 24px;
          }

          .highlight-wrapper:nth-last-child(1) {
            margin-bottom: 0;
          }

          .highlight-wrapper p {
            margin: 0;
          }

          .highlight-text .highlight-category {
            font-family: Roboto, sans-serif;
            font-size: 12px;
            line-height: 10px;
            color: #DB284E;
            letter-spacing: 0.1em;
            margin-bottom: 8px;
          }

          .highlight-img {
            width: 102px;
            min-width: 102px;
            max-height: 60px;
          }

          .highlight-text {
            width: calc(100% - 124px);
            margin-left: 12px;
          }

          .highlight-wrapper img {
            width: 100%;
            height: 95%;
            object-fit: cover;
          }

          .highlight-wrapper .highlight-title {
            font-family: Josefin Sans, sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: -0.05em;
            text-align: left;
            color: #000000;
            margin: 0;
            height: fit-content;
          }

          .fdn-article-card-desktop-type-7 .article-content .article-title a.title-anchor,
          p.highlight-title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3; 
            -webkit-box-orient: vertical;
          }

          .row-shimmer {
            width: 100%;
            box-sizing: border-box;
            padding-top: 30px;
          }
          .col-shimmer {
            display: grid;
            grid-template-columns: 5fr 15fr;
            grid-gap: 15px;
            box-sizing: border-box;
            padding: 0;
          }
          .col-shimmer:not(:first-child) {
            margin-top: 10px;
          }
          .col-shimmer div {
            width: 100%;
            box-sizing: border-box;
          }
          .col-shimmer-video {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 15px;
            box-sizing: border-box;
            padding: 0;
          }
          .col-shimmer-video:not(:first-child) {
            margin-top: 10px;
          }
          .col-shimmer-video div {
            width: 100%;
            box-sizing: border-box;
          }
        `}
      </style>
    </div>
  )
}

export default Sidebar
